import React from 'react'

import {Colors} from 'src/components/UI'
import {OrderAddress} from 'types/types'

type AddressTypeIconProps = {
    address: OrderAddress
    isRetour?: boolean
    // An address that is no longer part of the order (the original address of a retour)
    disabled?: boolean
    style?: React.CSSProperties
}

/**
 * P/D icon of an order address in a list, R for the retour address of a retour.
 */
export default function AddressTypeIcon({address, isRetour, disabled, style}: AddressTypeIconProps) {
    const color = disabled ? Colors.grey40 : isRetour ? Colors.retour : Colors[address.type]
    const className = isRetour ? 'mdi mdi-alpha-r-circle' : address.type === 'pickup' ? 'mdi mdi-alpha-p-circle' : 'mdi mdi-alpha-d-circle'

    return <i style={{color, fontSize: 18, marginRight: 12, ...style}} className={className} />
}
